module.exports = __webpack_public_path__ + "img/partner-10.6acbcf46.png";